import { Button, Modal, Textarea } from '@orobix/orobix-fe-components'
import { useMutation } from '@tanstack/react-query'
import { Formik, FormikErrors } from 'formik'
import { useTranslation } from 'react-i18next'

import { ErrorText } from '../../components/ErrorText/ErrorText'
import { Training } from '../../store/store.types'
import { update } from '../../utils/api'

type FormValues = {
  notes: string
}

type TrainingsNotesUpdateProps = {
  onClose: () => void
  onSuccess: () => void
  trainingId: number
  initialValues?: FormValues
  setNotes: React.Dispatch<React.SetStateAction<string>>
}

const TrainingsNotesUpdate = ({
  onClose,
  onSuccess,
  trainingId,
  initialValues = {
    notes: '',
  },
  setNotes,
}: TrainingsNotesUpdateProps) => {
  const { t } = useTranslation()

  const { mutate, isLoading, isError } = useMutation(
    (values: FormValues) =>
      update<Training>(`/trainings/${trainingId}/`, values),
    { onSuccess, useErrorBoundary: false }
  )

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors: FormikErrors<{ [field: string]: string }> = {}
        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        mutate(values)
        setSubmitting(false)
        setNotes(values.notes)
      }}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit}>
          <Modal
            size="md"
            onCloseRequest={onClose}
            title={t('Training notes')}
            footer={
              <Button
                label={t('Save')}
                type="action"
                disabled={isSubmitting}
                loading={isLoading}
              />
            }
          >
            <Textarea
              name="notes"
              id="notes"
              type="text"
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setFieldValue('notes', e.target.value)
              }
              onBlur={handleBlur}
              value={values.notes}
              error={!!(errors.notes && touched.notes)}
              errorMessage={errors.notes}
              disabled={isSubmitting}
            />

            {isError && <ErrorText />}
          </Modal>
        </form>
      )}
    </Formik>
  )
}

export default TrainingsNotesUpdate
